import { FunctionComponent, ReactElement, Fragment } from "react";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import BasicLink from "@components/core/links/BasicLink";

export interface BreadcrumbsItem {
  key: string;
  icon?: JSX.Element;
  link?: string;
  label?: string;
}

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbsItem[] | null;
  className?: string;
}

const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({
  breadcrumbs,
  className = "",
}) => {
  const { t } = useTranslation();

  const buildItemFrom = (
    item: BreadcrumbsItem,
  ): ReactElement | "" | undefined => {
    const itemClassName = item.icon ? "ml-8" : "";

    return item.label && <span className={itemClassName}>{t(item.label)}</span>;
  };

  return (
    <Breadcrumb className={`app-breadcrumbs ${className}`}>
      {breadcrumbs?.map((item) => (
        <Fragment key={item.key}>
          {item.link ? (
            <Breadcrumb.Item>
              <BasicLink to={item.link}>
                <>
                  {item.icon}
                  {item.label && buildItemFrom(item)}
                </>
              </BasicLink>
            </Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item>
              {item.icon}
              {item.label && buildItemFrom(item)}
            </Breadcrumb.Item>
          )}
        </Fragment>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
